import { render, staticRenderFns } from "./ground_ordered_edit.vue?vue&type=template&id=625ffcf2&"
import script from "./ground_ordered_edit.vue?vue&type=script&lang=ts&"
export * from "./ground_ordered_edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports